
export enum TipoUsuarioKeycloak {
    ADMIN = "ADMIN",
    CLIENTE = "CLIENTE",
    CONSUMIDOR = "CONSUMIDOR",
}